import React, { useState } from 'react'
import { Form, useFormikContext } from 'formik'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import CountryInput from '../country-input'
import StateInput from '../state-input'
import { FormattedMessage, useIntl } from 'react-intl'
import { BigButton } from '../../../../components/button'
import Input from '../normal-input'
import ZipInput from '../normal-input/br-zip'
import PhoneInput from '../normal-input/phone'
import { useLogin } from '../../../../hooks/common'
import PrivacyPart from '../privacy-part'

export default props => {
    useStyles(classes)
    const { countries, disableCountry, instantValidate, privacyPic, privacyInfo } = props
    const { values, isSubmitting } = useFormikContext()
    const intl = useIntl()
    const isLogin = useLogin()

    return <Form className={classes.Form}>
        <div className={classes.Boxes}>
            <div className={classes.Box}>
                <CountryInput
                    name="country"
                    label={"*"+intl.formatMessage({ id: 'country', defaultMessage: 'Country / Region' })}
                    countries={countries} disableCountry={disableCountry}/>
            </div>

            {
                !isLogin && <div className={classes.Box}>
                <Input
                    name="email"
                    label={"*"+intl.formatMessage({ id: 'email', defaultMessage: 'Email' })}
                />
            </div>
            }
            

            <div className={classes.Box}>
                <Input
                    name="firstName"
                    label={"*"+intl.formatMessage({ id: 'first_name', defaultMessage: 'First Name' })}
                />

                <Input
                    name="lastName"
                    label={"*"+intl.formatMessage({ id: 'last_name', defaultMessage: 'Last Name' })}
                />

                <Input
                    name="cpf"
                    label={`*CPF`}
                />

                <PhoneInput
                    name="phoneNumber"
                    instantValidate={instantValidate}
                    label={"*"+intl.formatMessage({ id: 'phone_number', defaultMessage: 'Phone Number' })}
                />
            </div>

            <div className={classes.Box}>
                <ZipInput
                    name="zipCode"
                    label={`*CEP`}
                    instantValidate={instantValidate}
                />

                <Input
                    name="streetAddress1"
                    label={"*"+intl.formatMessage({ id: 'address_line_1', defaultMessage: 'Address Line 1' })}
                    placeholder={"*"+intl.formatMessage({ id: 'address_line_1_placeholder', defaultMessage: 'Street name and street number, company name.' })}
                />
                <Input
                    name="unit"
                    label={"*"+intl.formatMessage({ id: 'number', defaultMessage: 'Number' })}
                />
                <Input
                    name="streetAddress2"
                    label={intl.formatMessage({ id: 'neighborhood', defaultMessage: 'Neighborhood' })}
                />
                <Input
                    name="city"
                    label={"*"+intl.formatMessage({ id: 'city', defaultMessage: 'City' })}
                />
                <StateInput
                    name="state"
                    label={"*"+intl.formatMessage({ id: 'state', defaultMessage: 'State / Provience' })}
                    countries={countries} />
            </div>
        </div>

        <div className={classes.Button}>
            <BigButton type="submit" loading={isSubmitting}><FormattedMessage id="save" defaultMessage={'Save'} /></BigButton>
        </div>

        <PrivacyPart privacyPic={privacyPic} privacyInfo={privacyInfo}/>
    </Form>
}